export default "__VITE_ASSET__BRDQksPF__"